// eslint-disable-next-line no-unused-vars
import React from 'react'
import { connect } from 'react-redux'
import { actions } from './'
import Cellphonerecharge from './Cellphonerecharge'
import * as checkoutActions from '../Checkout/actions'
import { push } from 'connected-react-router'

const mapStateToProps = ({
  cellphoneRecharge: {
    loadingFinalizeOrder,
    loadingScheduleOrder,
    errorMessage,
    secondFactorAuthentication,
    secondFactorAuthenticationOrderId,
    secondFactorAuthConfirmated,
    phone
  },
  oidc,
  checkout: {
    secondFactorAuthSuccess,
    authorized,
    status,
    messageError_,
    hasError,
    loadingResendToken,
    isCreatingPurchase,
    errorToken,
    titleError
  }
}) => {
  return {
    errorMessage,
    loadingFinalizeOrder,
    loadingScheduleOrder,
    oidc,
    secondFactorAuthentication:
      secondFactorAuthentication ||
      (secondFactorAuthenticationOrderId && !secondFactorAuthSuccess),
    secondFactorAuthenticationOrderId,
    secondFactorAuthConfirmated,
    authorizeWithTokenData: secondFactorAuthenticationOrderId && {
      secondFactorAuthSuccess,
      authorized,
      status,
      hasError,
      messageError: messageError_,
      loadingResendToken,
      isCreatingPurchase,
      errorToken,
      titleError
    },
    phone
  }
}

const mapDispatchToProps = dispatch => ({
  insertMobileRecharge: (serviceId, operatorKey, areaCode, phone) => {
    dispatch(
      actions.insertMobileRecharge(serviceId, operatorKey, areaCode, phone)
    )
  },
  scheduleMobileRecharges: (
    serviceId,
    operatorKey,
    areaCode,
    phone,
    initialScheduleDate,
    endScheduleDate,
    creditValue,
    pointValue
  ) =>
    dispatch(
      actions.scheduleMobileRecharges(
        serviceId,
        operatorKey,
        areaCode,
        phone,
        initialScheduleDate,
        endScheduleDate,
        creditValue,
        pointValue
      )
    ),
  clearErrorMessage: () => dispatch({ type: 'CLEAR_ERROR_MESSAGE' }),
  closeSecondFactorModal: () => dispatch({ type: 'CLOSE_SECOND_FACTOR' }),
  authorizeWithTokenResend: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      checkoutActions.authorizeWithTokenResend(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    ),
  authorizeWithToken: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend,
    lastTry = false
  ) =>
    dispatch(
      checkoutActions.authorizeWithToken(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend,
        lastTry
      )
    ),
  redirectConfirmation: orderId => dispatch(push(`/confirmation/${orderId}`)),
  clearRedux: () => {
    dispatch({ type: 'RESET_DATA' })
    dispatch({ type: 'CLEAR_CONFIRMED_ORDER_DATA' })
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Cellphonerecharge)



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/CellphonerechargeContainer.js